// extracted by mini-css-extract-plugin
export default {"userHeader":"UserHeader_userHeader__xEFYK","logo":"UserHeader_logo__OvFdx"};